import React from "react";
import { useSelector, RootStateOrAny } from "react-redux";
import { Route, Redirect, RouteProps } from "react-router-dom";
import { AuthState } from "../store/ducks/auth/types";
import {
  BACKOFFICE_VIVAZ_DEFAULT_ROUTE,
  isBackofficeVivazAllowedPath,
} from "../utils/backofficeVivazRoutes";

interface RouterWrapProps extends RouteProps {
  component: React.ComponentType<any>;
  isPrivate?: boolean;
  allowedRoute?: boolean;
  allowedRouteRedirect?: string;
}

export default function RouterWrap({
  component: Component,
  isPrivate = false,
  allowedRoute = true,
  allowedRouteRedirect,
  ...rest
}: RouterWrapProps) {
  const { signed: logged, usuarioBackofficeVivaz } = useSelector<
    RootStateOrAny,
    AuthState
  >((state) => state.user);

  return (
    <Route
      {...rest}
      render={(props) => {
        // 1) Se a rota é privada e o user não está logado => redireciona
        if (isPrivate && !logged) {
          // Ex: Salvar a rota atual antes de ir para "/" (opcional)
          // localStorage.setItem("@prevUrl", props.location.pathname);
          return <Redirect to="/" />;
        }

        if (
          isPrivate &&
          logged &&
          usuarioBackofficeVivaz &&
          !isBackofficeVivazAllowedPath(props.location.pathname)
        ) {
          return <Redirect to={BACKOFFICE_VIVAZ_DEFAULT_ROUTE} />;
        }

        // 2) Se a rota não é permitida => redireciona
        if (!allowedRoute) {
          return (
            <Redirect
              to={
                isPrivate && usuarioBackofficeVivaz
                  ? BACKOFFICE_VIVAZ_DEFAULT_ROUTE
                  : allowedRouteRedirect || "/"
              }
            />
          );
        }

        // 3) Caso contrário, renderiza o componente
        return <Component {...props} />;
      }}
    />
  );
}
